import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { privateRoutes } from './private-routes';
import { publicRoutes } from './public-routes';
import LayoutWrapper from 'src/components/ui/layout-wrapper';
import ThemeProvider from 'src/provider/theme';

export const routes = createBrowserRouter([...privateRoutes, ...publicRoutes], {
	basename: '/index.html'
});

export default function MainRoutes() {
	return (
		<ThemeProvider>
			<LayoutWrapper>
				<RouterProvider router={routes} />
			</LayoutWrapper>
		</ThemeProvider>
	);
}